export default __webpack_public_path__ + "static/media/IMG9637r.adf585e9.jpg";